import { render, staticRenderFns } from "./LegalAssistantDrawer.vue?vue&type=template&id=3f39c674&scoped=true"
import script from "./LegalAssistantDrawer.vue?vue&type=script&lang=js"
export * from "./LegalAssistantDrawer.vue?vue&type=script&lang=js"
import style0 from "./LegalAssistantDrawer.vue?vue&type=style&index=0&id=3f39c674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f39c674",
  null
  
)

export default component.exports